module.exports = __webpack_public_path__ + "static/media/faq-375.e28c9aed.jpg";